<template>
  <div>
    <transaction-type-form />
  </div>
</template>

<script>
import TransactionTypeForm from '../components/TransactionTypeForm.vue'

export default {
  components: {
    TransactionTypeForm,
  },
}
</script>

<style>

</style>
